export default function ({ $axios, $config }, inject) {
  const cms = $axios.create({
    baseURL: $config.cms.baseURL,
    headers: {
      ...($config.cms.token && { Authorization: `Bearer ${$config.cms.token}` }),
    },
  })

  inject('cms', cms)
}
